import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import {
  CcfBox,
  CcfButton,
  CcfTextField,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { updateselectedCustomer } from './simulator.slice';
import classes from './simulator.module.scss';
import { useDispatch } from 'react-redux';

/**@example */
const EditCustomer = ({
  openEditCustomerDialog,
  setOpenEditCustomerDialog,
  selectedContact,
  handleInputChange,
  editCustomerDetails,
  setEditCustomerDetails,
}: any) => {
  const dispatch = useDispatch();
  /**
   * @example
   */
  const resetEditDialogBox = () => {
    setOpenEditCustomerDialog(false);
  };

  /**@example */
  const handleSaveCustomerDetails = () => {
    dispatch(updateselectedCustomer(editCustomerDetails));
    setOpenEditCustomerDialog(false);
  };
  return (
    <CcfBox>
      <Dialog
        onClose={resetEditDialogBox}
        open={openEditCustomerDialog}
        fullWidth={true}
        maxWidth="md"
        scroll="paper"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle sx={{ fontWeight: '600' }}>
          {'Edit Customer Details'}
        </DialogTitle>
        <DialogContent className={classes.blockContainer}>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              First Name
            </CcfTypography>
            <CcfTextField
              id="firstName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.firstName
                  ? editCustomerDetails?.firstName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  firstName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Middle Name
            </CcfTypography>
            <CcfTextField
              id="lastName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.middleName
                  ? editCustomerDetails?.middleName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  middleName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
          <CcfBox className={classes.feildBlock}>
            <CcfTypography className={classes.tableHeaderText}>
              Last Name
            </CcfTypography>
            <CcfTextField
              id="lastName"
              variant="outlined"
              size="small"
              value={
                editCustomerDetails?.lastName
                  ? editCustomerDetails?.lastName
                  : ''
              }
              focused={false}
              style={{ width: '80%' }}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setEditCustomerDetails({
                  ...editCustomerDetails,
                  lastName: event.target.value,
                });
              }}
            />{' '}
          </CcfBox>
        </DialogContent>
        <DialogActions>
          <CcfButton onClick={resetEditDialogBox}>
            <CcfTypography>Cancel</CcfTypography>
          </CcfButton>
          <CcfButton primary onClick={handleSaveCustomerDetails}>
            <CcfTypography>Save</CcfTypography>
          </CcfButton>
        </DialogActions>
      </Dialog>
    </CcfBox>
  );
};

export default EditCustomer;
